import { Modal } from '../../shared/ui';

export interface IJournalModalPanel {
  isShow: boolean;
  title?: React.ReactNode;
  onClick: () => void;
  children?: React.ReactNode;
}

export const JournalModalPanel = ({ isShow, title, onClick, children }: IJournalModalPanel) => {
  return (
    <Modal isOpen={isShow} onClose={onClick} size="xl" title={title}>
      {children}
    </Modal>
  );
};
